import 'jquery-zoom';

export default () => {
    //todo zoom prodotto
    jQuery(document).ready(function () {
        var $list_prodotto = $(".preview-product-zoom");
        // console.log($list_prodotto);
        if ($list_prodotto.length > 0) {
            $list_prodotto.each(function () {
                var imgUrl = $(this).find('.single-prodotto').attr('data-img-full');
                if ($(window).width() > 768) {
                    $(this).find(".img-zoom").zoom({ url: imgUrl });
                }
                $(this).on("click", function () {
                    var $modal = $('#productModal');
                    $modal.find('img').attr('src', imgUrl);
                    $modal.modal('show');
                });
            });
        }
    });
};



// WEBPACK FOOTER //
// ./scripts/libs/fcb-lista-prodotti.js